import { useRef } from 'react';
import isEqual from 'react-fast-compare';

export const useDeepMemo = <T>(memoFn: () => T, key: unknown[]): T => {
  const ref = useRef<{ key: unknown[]; value: T }>();
  if (!ref.current || !isEqual(key, ref.current.key)) {
    ref.current = { key, value: memoFn() };
  }

  return ref.current.value;
};
